// import * as React from "react";
import React, { useState } from "react"; // นำเข้า React และ useState ในบรรทัดเดียวกัน
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import SignatureCanvas from "react-signature-canvas";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import Typography from "@mui/material/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ClearIcon from "@mui/icons-material/Clear";
import { APIEndpoint } from "../../../../client/apiconfig"; // นำเข้า BASE_URL จาก apiConfig
import axios from "axios";

export default function AlertDialog() {
  const [open, setOpen] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState<File | null>(null);
  const [sigPad, setSigPad] = React.useState<SignatureCanvas | null>(null);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [imagePreview, setImagePreview] = React.useState<string | null>(null); // State for image preview
  // const [base64Signature, setBase64Signature] = useState<string | null>(null);
  const [signatureData, setsignature] = useState<string | null>(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    const storedDataPerson = sessionStorage.getItem("Data");

    if (!storedDataPerson) {
      console.error("No data found in localStorage");
      return;
    }

    let parsedDataPerson;
    try {
      parsedDataPerson = JSON.parse(storedDataPerson);
    } catch (error) {
      console.error("Error parsing JSON from localStorage:", error);
      return;
    }

    const accountId = parsedDataPerson?.result?.data?.account_id;
    if (!accountId) {
      console.error("No account_id found in parsed data");
      return;
    }

    let payload: { account_id: string; image?: string } = {
      account_id: accountId,
    };

    if (sigPad) {
      const signatureDataURL = sigPad.toDataURL();
      const base64Signature = signatureDataURL.replace(
        /^data:image\/(png|jpg);base64,/,
        ""
      );
      // setBase64Signature(base64Signature);
      // console.log('sigPad:', base64Signature);

      if (base64Signature) {
        payload.image = base64Signature;
      }
    }

    if (selectedFile) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result
          ?.toString()
          .replace(/^data:image\/(png|jpg);base64,/, "");
        if (base64String) {
          // console.log('selectedFile:', base64String);
          if (!payload.image) {
            payload.image = base64String;
          }
          // Send data to API
          sendToApi(payload);
        }
      };
      reader.readAsDataURL(selectedFile);
    } else {
      // If there's no selectedFile, send payload with base64Signature only
      if (payload.image) {
        sendToApi(payload);
      }
    }

    setOpen(false);
    setAlertOpen(true);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      setSelectedFile(file);
      // Create preview for displaying image
      setImagePreview(URL.createObjectURL(file));
    } else {
      setSelectedFile(null);
      setImagePreview(null);
    }
  };
    // Function to send data to API
    const sendToApi = async(payload: { account_id: string; image?: string }) => {
      await fetch(APIEndpoint.SingDialogSendToApi, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Basic TEtQa3Bhc3NwT2twb2twTzpPUEtwYVBPYWtza2NoeXU='
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((data) => {
          setsignature(data.result.image_base64);
          sessionStorage.setItem("sign_base64", JSON.stringify(data.result.image_base64));
          // console.log('Response from API:', data);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    };

  const clearSignature = () => {
    if (sigPad) {
      sigPad.clear();
    }
    setSelectedFile(null);
    setImagePreview(null); // Clear the uploaded image
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  React.useEffect(() => {
    if (alertOpen) {
      const timer = setTimeout(() => {
        handleAlertClose(); // Automatically close the alert dialog after 3 seconds
      }, 3000);
      return () => clearTimeout(timer); // Cleanup timer on component unmount
    }
  }, [alertOpen]);

  return (
    <React.Fragment>
      {signatureData ? (
        <Button
          onClick={handleClickOpen}
          variant="contained"
          sx={{
            borderRadius: "20px",
            backgroundColor: "#2F4491",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#2F4491",
            },
          }}
        >
          แก้ไขลายเซ็น
        </Button>
      ) : (
        <Button
          onClick={handleClickOpen}
          variant="contained"
          sx={{
            borderRadius: "20px",
            backgroundColor: "#2F4491",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#2F4491",
            },
          }}
        >
          สร้างลายเซ็นใหม่
        </Button>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {signatureData ? <EditIcon /> : <EditIcon />}{" "}
          {/* ใช้ไอคอน Clear แทน Edit ถ้าไม่มีลายเซ็น */}
          {signatureData ? "แก้ไขลายเซ็น" : "สร้างลายเซ็นใหม่"}{" "}
          {/* เปลี่ยนข้อความตามลายเซ็น */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end", // จัดปุ่มไปที่มุมขวา
            }}
          >
            <input
              accept="image/*"
              type="file"
              onChange={handleFileChange}
              style={{ display: "none" }}
              id="upload-file"
            />
            <label htmlFor="upload-file">
              <Button
                variant="contained"
                component="span"
                sx={{
                  borderRadius: "20px",
                  backgroundColor: "#2F4491",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#2F4491",
                  },
                }}
              >
                {"อัปโหลดรูป ลายเซ็น"}
              </Button>
            </label>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box
            sx={{
              position: "relative", // Position the icon absolutely within this container
              backgroundColor: "#eaeef7",
              borderRadius: "15px",
              p: 2,
              mt: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
              width: "45ch", // Fixed width
              mx: "auto", // Center horizontally within the parent container
            }}
          >
            {/* Trash icon */}
            <IconButton
              onClick={clearSignature}
              sx={{
                position: "absolute",
                top: 10,
                right: 10,
                color: "#000000", // Black color for trash icon
              }}
            >
              <ClearIcon />
            </IconButton>

            {/* Conditionally render the uploaded image or signature canvas */}
            {imagePreview ? (
              <img
                src={imagePreview}
                alt="Uploaded Signature"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  borderRadius: "10px",
                }}
              />
            ) : (
              <SignatureCanvas
                penColor="black"
                canvasProps={{
                  width: 500,
                  height: 200,
                  className: "sigCanvas",
                  style: { borderRadius: "10px" },
                }}
                ref={(ref) => setSigPad(ref)}
              />
            )}
          </Box>

          {selectedFile && (
            <Box mt={2} display="flex" alignItems="center">
              <p>ไฟล์ที่เลือก: {selectedFile.name}</p>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", margin: "10px" }}>
          <Stack direction="row" spacing={2}>
            <Button
              onClick={handleClose}
              variant="outlined"
              color="error"
              sx={{
                width: "100px",
                borderRadius: "20px",
              }}
            >
              ยกเลิก
            </Button>
            <Button
              onClick={handleSave}
              variant="contained"
              sx={{
                width: "100px",
                backgroundColor: "#2F4491",
                borderRadius: "20px",
                "&:hover": {
                  backgroundColor: "#253672",
                },
              }}
              href="signature"
            >
              ยืนยัน
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>

      {/* Alert Dialog for notifications */}
      <Dialog
        open={alertOpen}
        onClose={handleAlertClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center", // Center horizontally
              alignItems: "center", // Center vertically
            }}
          >
            <CheckCircleIcon
              sx={{ color: "#2F4491", width: "100px", height: "100px" }}
            />
          </Box>
          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "center", // Center horizontally
              fontSize: "25px",
              fontWeight: "bold", // Makes the text bold
            }}
          >
            เพิ่มลายเซ็นสำเร็จ
          </Box>

          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "center", // Center horizontally
            }}
          >
            ลายเซ็นของคุณถูกบันทึกเรียบร้อยแล้ว!
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
